export default class SocketFilterMessageTypes {
	static USER_ALWAYS = 100;
	static USER_IN_CHATS = 101;
	static USER_IN_MATCH = 102;
	static USER_IN_TOURNAMENT = 103;
	static SOCKET_UPDATES = 110;
	static LIVE_MATCHES = 111;
	static SITE_ACTIVITY = 112;
}

